<div class="row">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info">Adding Permission to {{roleGroup['name']}}</h3>
  </div>
  <div class="col-sm-12 text-end alert">
    <a [routerLink]="['/admin/permission/new',0]" class="btn btn-primary"> <i class="fa fa-plus"></i> Add New role</a>
  </div>
  <div class="col-sm-12">
    <h3 class="sub-title">List of Permissions for {{roleGroup['name']}}</h3>
  </div>
  <div class="col-sm-12 text-end">
    <a [routerLink]="['/admin/permission/new']" class="btn btn-primary"> <i class="fa fa-plus"></i></a>
  </div>
</div>


<form  [formGroup]="searchRolesForm" class="mt-5">
  <div class="row">
            <div class="col-sm-3" > Search Permission</div>
            <div class="col-sm-4" >
                <input   formControlName="searchInput" class="form-control"/>
            </div>
     </div>
</form>
<hr/>
<ul>
    <li *ngFor="let roleItem of roleList;" style="list-style: none;">
    <button (click)="addPermissionToRoleGroup(roleItem.id)" class="mt-1"> Add Role</button> {{roleItem.text}}
</li>
</ul>
